export const PURCHASE = 0
export const MODIFICATION = 1
export const RENEWAL = 2
export const benefits = [
  {
    plan: 'Gratuito',
    headers: [
      'Ideal para hogares',
      '1 localización',
      '0 cuentas invitado',
    ],
    modules: [
      'App web y mobile (iOS y Android)',
      '3 Puntos de Medición (máximo)',
      '7 días de mediciones instantaneas',
      '2 años de acumulados diarios de energia',
      "<span style='text-decoration: line-through;'>Potencia adquirida y energía por hora</span>",
      'Notificaciones en app únicamente',
      'Acceso a secciones básicas',
    ],
  },
  {
    plan: 'Lite',
    headers: [
      'Ideal para hogares (uso avanzado) y comercios pequeños',
      '1 localización',
      '0 cuentas invitado',
    ],
    modules: [
      'App web y mobile (iOS y Android)',
      '5 Puntos de Medición (máximo)',
      '30 días de mediciones instantaneas',
      '4 años de acumulados diarios de energia',
      "<span style='text-decoration: line-through;'>Potencia adquirida y energía por hora</span>",
      'Notificaciones en app únicamente',
      'Acceso a secciones básicas',
    ],
  },
  {
    plan: 'Basico',
    headers: [
      'Ideal para pequeñas empresas',
      '1 localización',
      '2 cuentas invitado',
    ],
    modules: [
      'App web y mobile (iOS y Android)',
      '10 Puntos de Medición (ampliable)',
      '30 días de mediciones instantaneas',
      '4 años de acumulados diarios de energia',
      'Potencia adquirida y energía por hora',
      'Notificaciones en app, mail y telegram',
      'Acceso a secciones avanzadas',
    ],
  },
  {
    plan: 'Profesional',
    headers: [
      'Ideal para empresas medianas multi-sitio',
      '5 localizaciones',
      '5 cuentas invitado',
    ],
    modules: [
      'App web y mobile (iOS y Android)',
      '10 Puntos de Medición (ampliable)',
      '90 días de mediciones instantaneas',
      '4 años de acumulados diarios de energia',
      'Potencia adquirida y energía por hora',
      'Notificaciones en app, mail y telegram',
      'Acceso a secciones avanzadas',
    ],
  },
  {
    plan: 'Experto',
    headers: [
      'Ideal grandes organizaciones y profesionales en gestión de la energía',
      'Localizaciones ilimitadas',
      '10 cuentas invitado',
    ],
    modules: [
      'App web y mobile (iOS y Android)',
      '10 Puntos de Medición (ampliable)',
      '90 días de mediciones instantaneas',
      '4 años de acumulados diarios de energia',
      'Potencia adquirida y energía por hora',
      'Notificaciones en app, mail y telegram',
      'Acceso a secciones avanzadas',
    ],
  },
  {
    plan: 'Subfacturacion_Lite',
    headers: [
      'Ideal grandes organizaciones y profesionales en gestión de la energía',
      'Localizaciones ilimitadas',
      '10 cuentas invitado',
    ],
    modules: [
      'App web y mobile (iOS y Android)',
      '10 Puntos de Medición (ampliable)',
      '90 días de mediciones instantaneas',
      '4 años de acumulados diarios de energia',
      'Potencia adquirida y energía por hora',
      'Notificaciones en app, mail y telegram',
      'Acceso a secciones avanzadas',
    ],
  },
  {
    plan: 'Staff',
    headers: [
      'Ideal para pruebas internas',
    ],
    modules: [
      'Todo',
    ],
  },
];

export const planLevels = [
  {
    name: 'Gratuito',
    plan_level: 0
  },
  {
    name: 'Lite',
    plan_level: 1
  },
  {
    name: 'Basico',
    plan_level: 2
  },
  {
    name: 'Profesional',
    plan_level: 3
  },
  {
    name: 'Experto',
    plan_level: 4
  },
  {
    name: 'Staff',
    plan_level: 6
  }
]

export const calculateExpirationDate = (datestr) => {
  if (!datestr || typeof datestr !== 'string') return '-';

  const fecha = datestr.split(' ')[0];
  const parts = fecha.split('-');

  if (parts.length !== 3) return '-';

  const [year, month, day] = parts.map(Number);

  if (isNaN(year) || isNaN(month) || isNaN(day)) return '-';

  const date = new Date(year, month - 1, day);
  return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
};

export const getPlanLevel = plan => {
  return planLevels.find(item => item.name === plan)?.plan_level;
};